import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../environments/environment';

@Injectable()
export class CommunicationService {

  env = environment;

  constructor(private readonly http: HttpClient) { }

  userCallback(data: any) {
    return this.http.post(this.env.webApiUrl + 'api/communication/UserCallback', data);
  }

  userCallbackForLMSInsert(data: any) {
    return this.http.post(this.env.webApiUrl + 'api/communication/UserCallbackForLMSInsert', data);
  }

  createOobaHomeLoanAdvance() {
    return this.http.post(this.env.webApiUrl + 'api/communication/CreateOobaHomeLoanAdvance', null);
  }

  userAuthenticateWithOoba() {
    return this.http.post(this.env.webApiUrl + 'api/communication/UserAuthenticateWithOoba', null);
  }

  getOobaAuthenticateResponse() {
    return this.http.post(this.env.webApiUrl + 'api/communication/GetOobaAuthenticateResponse', null);
  } 

  getSplQualificationDecision() {
    return this.http.post(this.env.webApiUrl + 'api/communication/GetSplQualificationDecision', null);
  }

  transferUserToIdp(data: any) {
    return this.http.post(this.env.webApiUrl + 'api/communication/TransferUserToIdp', data);

  }

  userCallbackForDebtBusterLeads(data: any) {
    return this.http.post(this.env.webApiUrl + 'api/communication/TransferUserToDebtbuster', data);
  }

  getSplOfferData(){
    return this.http.post(this.env.webApiUrl + 'api/communication/GetSplOfferData', null);
  }

  transferUserToSplEzflow(data: any ) {
    return this.http.post(this.env.webApiUrl + 'api/communication/TransferUserToSpl', data);
  } 
  requestCoachAssistanceForPassword (data: any) {    
    return this.http.post(this.env.webApiUrl + 'api/UserCallback/UserCallbackForForgotPassword', data);
  }
}
